import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { BaseModule } from '../../../pages/questionModuleTypes';
import MultilineText from '../../MultilineText';
import { observer } from 'mobx-react';

interface Props {
  questionModule: BaseModule,
  renderCluster: () => JSX.Element
}

type LocalStyles = 'headerSection';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  headerSection: {
    textAlign: 'left',
    marginBottom: theme.spacing.unit * 2,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionModule extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props)
  }

  public render() {
    const {classes} = this.props;
    return (
      <div key={this.props.questionModule.id + "moduleContainer"}>
        <div key={this.props.questionModule.id + "moduleHeader"} className={classes.headerSection}>
          {
            this.props.questionModule.title !== '' &&
            <Typography variant="h4">
              {this.props.questionModule.title}
            </Typography>
          }
          {
            this.props.questionModule.description !== '' &&
            <Typography variant='body1' key={'description'}>
              <MultilineText text={this.props.questionModule.description}/>
            </Typography>
          }
        </div>
        {
          this.props.renderCluster()
        }
      </div>
    )
  }
}

export default withStyles(localStyles)(QuestionModule);
